export const statusCodes = {
    sesionInvalida: { code: -1, message: "Sesión Inválida" },
    ok: { code: 0, message: "Operación se ha realizado de forma exitosa." },
    errorConexionServidor: { code: 1, message: "Error del lado del servidor por una excepción." },
    usuarioPasswordIncorrecto: { code: 2, message: "Usuario o Password Incorrecto." },
    noPermiso: { code: 3, message: "No tiene permiso para realizar la acción." },
    datoIncompletoFormulario: { code: 4, message: "Faltan datos requeridos" },
    datosFormularioNoAdecuados: { code: 5, message: "Datos del formulario no adecuados para la acción." },
    datosNoExistentes: { code: 6, message: "Datos no existentes.", statusCode: 404 },
    usuarioBloqueado: { code: 7, message: "Usuario bloqueado." },
    usuarioDeshabilitado: { code: 8, message: "Usuario deshabilitado." },
    rolNoPerteneciente: { code: 9, message: "Rol no perteneciente." },
    usuarioNoVerificado: { code: 10, message: "Usuario no verificado." },
    passwordIncorrecto: { code: 11, message: "Password Incorrecto" },
    tokenExpirado: { code: 12, message: "Token expirado." },
    datosDuplicados: { code: 13, message: "Contiene información que no puede ser duplicada" },
    tokenInvalido: { code: 14, message: "Token inválido." },
    pinInvalido: { code: 15, message: "PIN inválido." },
    codigoExistente: { code: 16, message: "Código ya existe." },
    tipoExistente: { code: 16, message: "Tipo ya existe." },
    elementoUtilizado: { code: 17, message: "Elemento ya utilizado, no se puede eliminar." },
    nombreExistente: { code: 18, message: "Nombre ya está siendo utilizado." },
    lineaExistente: { code: 19, message: "Línea ya existe." },
    diarioExistente: { code: 20, message: "El Diario de presupuesto ya existe." },
    codigoEmpleadoExistente: { code: 23, message: "Ya existe un usuario con ese código." },
    usuarioExistente: { code: 24, message: "El Usuario ingresado ya existente." },
    generarReporteFallido: { code: 21, message: "Error al generar el reporte, intente nuevamente." },
}













